<template>
    <el-row>
        <el-table
                :max-height="height"
                @sort-change="sortChange"
                ref="orderTable"
                :data="orders"
                style="width: 100%"
                :highlight-current-row="true"
        >
            <el-table-column v-if="hasSelect"
                             type="selection"
                             width="50">
            </el-table-column>

            // 图片
            <el-table-column fixed label="图片" v-if="hasImage">
                <template slot-scope="scope">
                    <image-col :order="scope.row"></image-col>
                </template>
            </el-table-column>

            // 分类
            <el-table-column v-if="hasKind" prop="kind_display" width="90" label="分类"></el-table-column>

            // 订单编号
            <el-table-column sortable="custom" prop="id" v-if="hasId" width="150" label="订单编号/款号">
                <template slot="header" slot-scope="scope">订单编号/款号<i v-show="idSortLoading" class="el-icon-loading"></i>
                </template>

                <template slot-scope="scope">
                    <base-id-col :order="scope.row"></base-id-col>
                </template>
            </el-table-column>

            // 下单人
            <el-table-column v-if="hasUser" prop="created_user.username" width="60"
                             label="下单人"></el-table-column>

            // 下单数量
            <el-table-column v-if="hasOrderNum" width="80" label="下单数量">
                <template slot-scope="scope">
                    <order-num-col :order="scope.row"/>
                </template>

            </el-table-column>

            // 订单进度
            <el-table-column v-if="hasOrderStatus" prop="status_display" label="订单进度"></el-table-column>

            // 审核
            <el-table-column width="90" v-if="hasVerifyStatus" label="审核">
                <template slot-scope="scope">
                    <verify-col :order="scope.row"/>
                </template>
            </el-table-column>

            // 版房交接
            <el-table-column v-if="hasStereoStatus" label="版房交接">
                <template slot-scope="scope">
                    <stereo-col :order="scope.row"></stereo-col>
                </template>
            </el-table-column>

            // 面料进度
            <el-table-column v-if="hasApplyMainFinish" label="面料进度">
                <template slot-scope="scope">
                    <apply-main-finish :order="scope.row"/>
                </template>
            </el-table-column>

            // 面料预计入库
            <el-table-column width="200" v-if="hasApplyMainFinish" label="面料入库日期">
                <template slot-scope="scope">
                    <apply-main-finish-date :order="scope.row"/>
                </template>
            </el-table-column>

            // 辅料进度
            <el-table-column v-if="hasApplySubFinish" label="辅料进度">
                <template slot-scope="scope">
                    <apply-sub-finish :order="scope.row"/>
                </template>
            </el-table-column>

            // 辅料进度
            <el-table-column width="200" v-if="hasApplySubFinish" label="辅料入库信息">
                <template slot-scope="scope">
                    <apply-sub-finish-date :order="scope.row"/>
                </template>
            </el-table-column>

            // 加急
            <el-table-column v-if="hasUrgent" width="70" label="加急">
                <template slot-scope="scope">
                    <urgent-col :order="scope.row"/>
                </template>
            </el-table-column>

            // 生产进度
            <el-table-column v-if="hasProduceInfoStatus" prop="produceinfo.current_display"
                             label="生产进度"></el-table-column>

            // 当前工艺
            <el-table-column width="100" v-if="hasCurrentCraft" prop="produceinfo.current_display" label="当前工艺">
                <template slot-scope="scope">
                    <current-craft-col :order="scope.row"></current-craft-col>
                </template>
            </el-table-column>

            // 裁剪
            <el-table-column v-if="hasCut" label="裁剪">
                <template slot-scope="scope">
                    <craft-num :order="scope.row" :craft-type="1"/>
                </template>
            </el-table-column>

            // 缝纫
            <el-table-column v-if="hasSew" label="缝纫">
                <template slot-scope="scope">
                    <craft-num :order="scope.row" :craft-type="2"/>
                </template>
            </el-table-column>

            // 印花
            <el-table-column v-if="hasYinHua" label="印花">
                <template slot-scope="scope">
                    <craft-num :order="scope.row" :craft-type="3"/>
                </template>
            </el-table-column>

            // 水洗
            <el-table-column v-if="hasShuiXi" label="水洗">
                <template slot-scope="scope">
                    <craft-num :order="scope.row" :craft-type="6"/>
                </template>
            </el-table-column>

            // 绣花
            <el-table-column v-if="hasXiuHua" label="绣花">
                <template slot-scope="scope">
                    <craft-num :order="scope.row" :craft-type="7"/>
                </template>
            </el-table-column>

            // 其它
            <el-table-column v-if="hasOther" label="其它"> /</el-table-column>

            // 后道成品
            <el-table-column v-if="hasAfterHandle" label="后道成品"> /</el-table-column>

            // 预计入库
            <el-table-column v-if="hasProduceEstimate" prop="produceinfo.estimate_date" label="预计入库"></el-table-column>

            // 规定时间
            <el-table-column v-if="hasPlanDate" width="95" prop="plan_date"
                             label="规定时间"></el-table-column>

            // 入库状态
            <el-table-column v-if="hasFinishInStorage" width="95" prop="instorage.current_display"
                             label="入库状态"></el-table-column>

            // 通知入库
            <el-table-column v-if="hasPlanInStorage" width="95" prop="in_storage_amount" label="通知入库"></el-table-column>

            // 已入库数量
            <el-table-column v-if="hasFinishInStorage" width="95" prop="finish_in_storage"
                             label="已入库"></el-table-column>
            // 编辑/查看
            <el-table-column v-if="showModify" fixed="right" width="70" label="编辑">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="_clickModify(scope.row)">编辑</el-button>
                </template>
            </el-table-column>

            // 删除订单
            <el-table-column v-if="show_delete" fixed="right" label="删除">
                <template slot-scope="scope">
                    <el-button size="mini" @click="deleteOrder(scope.row)" type="danger">删除</el-button>
                </template>
            </el-table-column>

            // 更多信息
            <el-table-column fixed="right" label="更多信息">
                <template slot-scope="scope">
                    <order-more :order="scope.row"/>
                </template>
            </el-table-column>

            // 备注
            <el-table-column v-if="hasRemark" fixed="right" label="备注">
                <template slot-scope="scope">
                    <remark-col :order="scope.row"/>
                </template>
            </el-table-column>
        </el-table>
    </el-row>

</template>

<script>
    import ImageCol from "./ImageCol"
    import BaseIdCol from "./BaseIdCol"
    import StereoCol from "./StereoCol"
    import ApplyMainFinish from "./ApplyMainFinish"
    import ApplySubFinish from "./ApplySubFinish"
    import UrgentCol from "./UrgentCol"
    import CurrentCraftCol from "./CurrentCraftCol"
    import RemarkCol from "./RemarkCol"
    import CraftNum from "./CraftNum"
    import VerifyCol from "./VerifyCol"
    import OrderNumCol from "./OrderNumCol"
    import OrderMore from "./OrderMore"
    import ApplyMainFinishDate from "./ApplyMainFinishDate"
    import ApplySubFinishDate from "./ApplySubFinishDate"

    const ClipboardJS = require('clipboard')
    export default {
        name: "OrderTable",
        data() {
            window.onresize = () => {
                this.height = document.documentElement.clientHeight - 180
            }
            return {
                count: 0,
                idSortLoading: false,
                height: 0,
            }
        },
        props: {
            orders: {
                type: Array[Object],
                required: true,
            },
            items: {
                type: Array[String],
                default: function () {
                    return [
                        'orderStatus',          // 订单进度
                        'verifyStatus',         // 审核状况
                        'stereoStatus',         // 版房状况
                        'applyMainFinish',      // 面料采购状况
                        'applySubFinish',       // 辅料采购状况
                        'urgent',               // 加急状态
                        'produceInfoStatus',    // 生产进度
                        'currentCraft',         // 当前工艺
                        'cut',                  // 裁剪数量
                        'sew',                  // 缝纫数量
                        'yinHua',               // 印花
                        'shuiXi',               // 水洗
                        'xiuHua',               // 绣花
                        'other',                // 其它
                        'afterHandle',          // 后道
                        'produceEstimate',      // 生产预计入库日期
                        'planDate',             // 计划规定日期
                        'planInStorage',        // 通知入库
                        'finishInStorage',      // 入库数量
                    ]
                }
            },
            select: {
                type: Boolean,
                default: false,
            },
            showModify: {
                type: Boolean,
                default: false
            },
            clickModify: {
                type: Function,
                require: false,
                default: function () {
                    return () => {
                    }
                }
            },
            sortUrl: {
                type: String,
                default: '/order_platform/api/platform_orders/?ordering=id',
            },
            show_delete: {
                type:Boolean,
                default: false,
            }
        },
        components: {
            ApplySubFinishDate,
            ApplyMainFinishDate,
            OrderMore,
            OrderNumCol,
            ImageCol, BaseIdCol, StereoCol, ApplyMainFinish,
            ApplySubFinish, UrgentCol, CurrentCraftCol, RemarkCol,
            CraftNum, VerifyCol
        },
        methods: {
            /**
             * 排序发送变化时候会触发该事件
             * @param column
             * @param prop
             * @param order
             */
            sortChange({column, prop, order}) {
                const orderMap = new Map([
                    ['descending', ''],
                    ['ascending', '-'],
                ])

                const params = {
                    ordering: orderMap.get(order) + prop
                }

                this.idSortLoading = true
                this.$getRequest(this.sortUrl, params)
                    .then(response => {
                        this.idSortLoading = false
                        this.$emit('handlesort', response)
                    })
                    .catch(() => {
                        this.idSortLoading = false
                    })
            },

            load_copy_clip() {
                new ClipboardJS('.copy-btn');
            },
            hasItem(item) {
                return this.items.indexOf(item) > -1
            },
            _clickModify(order) {
                this.clickModify(order)
            },
            setCurrentRow(row) {
                this.$refs.orderTable.setCurrentRow(row)
            },
            deleteOrder(order){
               this.$emit("deleteOrder", order)
            },
        },

        computed: {
            hasSelect() {           // 必选项
                return this.select
            },
            hasImage() {            // 必选项
                return true
            },
            hasKind() {             // 必选项
                return true
            },
            hasId() {               // 必选项
                return true
            },
            hasUser() {             // 必选项
                return true
            },
            hasOrderNum() {         // 必选项
                return true
            },
            hasOrderStatus() {
                return this.hasItem('orderStatus')
            },
            hasVerifyStatus() {
                return this.hasItem('verifyStatus')
            },
            hasStereoStatus() {
                return this.hasItem('stereoStatus')
            },
            hasApplyMainFinish() {
                return this.hasItem('applyMainFinish')
            },
            hasApplySubFinish() {
                return this.hasItem('applySubFinish')
            },
            hasUrgent() {
                return this.hasItem('urgent')
            },
            hasProduceInfoStatus() {
                return this.hasItem('produceInfoStatus')
            },
            hasCurrentCraft() {
                return this.hasItem('currentCraft')
            },
            hasCut() {
                return this.hasItem('cut')
            },
            hasSew() {
                return this.hasItem('sew')
            },
            hasYinHua() {
                return this.hasItem('yinHua')
            },
            hasShuiXi() {
                return this.hasItem('shuiXi')
            },
            hasXiuHua() {
                return this.hasItem('xiuHua')
            },
            hasOther() {
                return this.hasItem('other')
            },
            hasAfterHandle() {
                return this.hasItem('afterHandle')
            },
            hasProduceEstimate() {
                return this.hasItem('produceEstimate')
            },
            hasPlanDate() {
                return this.hasItem('planDate')
            },
            hasPlanInStorage() {
                return this.hasItem('planInStorage')
            },
            hasFinishInStorage() {
                return this.hasItem('finishInStorage')
            },
            hasRemark() {
                return true           // 必选项
            },

        },
        created() {
            this.load_copy_clip()
            this.height = document.documentElement.clientHeight - 180
        }
    }
</script>

<style scoped>

</style>